module.exports = __webpack_public_path__ + "img/email-icon.62c95d7a.svg";